import { converterDataEua } from "_utils/Data";
import { TIPO_SOLICITACAO_PLACA } from "../../SolicitacaoPlaca/constants/tipoSolicitacaoPlaca";
import { IOrdenacao } from "../../SolicitacaoPlaca/interfaces/IOrdenacao";
import { IFiltrosLotesTerceiros } from "../interfaces/IFiltrosLotesTerceiros";

interface IParametrosBusca {
  filtros: IFiltrosLotesTerceiros;
  pagina: number;
  limite: number;
  ordenacao: IOrdenacao;
}

export function montarParametrosLotesTerceiros({
  filtros,
  pagina,
  limite,
  ordenacao,
}: IParametrosBusca): URLSearchParams {
  const parametros = new URLSearchParams({
    tipo: TIPO_SOLICITACAO_PLACA.TERCEIROS,
    pagina: String(pagina),
    limite: String(limite),
    ordenarPor: ordenacao.campo,
    ordem: ordenacao.direcao,
  });
  const [inicio, fim] = filtros.periodoEnvio ?? [];

  filtros.idLote.forEach((idLote) => parametros.append("idLote", idLote));
  if (filtros.idFornecedor)
    parametros.set("idFornecedor", String(filtros.idFornecedor));
  if (filtros.idUsuario) parametros.set("idUsuario", String(filtros.idUsuario));
  if (inicio) parametros.set("dataInicio", converterDataEua(inicio) as string);
  if (fim) parametros.set("dataFim", converterDataEua(fim) as string);

  return parametros;
}
